import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import AdditionPlanView from "./AdditionPlanView";
import { FETCH_ADDITIONAL_PLANS } from "./graphql";

const AdditionPlansView = ({ id, tryAddAdditionalPlan }) => {
  const { loading, error, data } = useQuery(FETCH_ADDITIONAL_PLANS, {
    variables: { id },
  });

  if (loading)
    return (
      <div className="p-10 relative">
        <InlineSpinner />
      </div>
    );

  if (error) return <Errors error={error} />;

  const parentPlan = data.productionPlan;

  return (
    <div className="space-y-8">
      {parentPlan.state === "PROCESSING" && !parentPlan.parent ? (
        <div className="card mt-8 space-y-8">
          {parentPlan.children.length > 0 ? (
            <div className="space-y-8">
              {parentPlan.children.map((child) => (
                <AdditionPlanView key={child.id} plan={child} />
              ))}
            </div>
          ) : null}

          <div>
            <div className="opacity-70">
              The original plan has started processing, you can only reduce the
              qty of the current plan, which will release the supplier stock if
              there is any. If you want to append new products or add qty, you
              add additional plans. This additional plans manage the supplier
              stock and help update products to Odoo.
            </div>
            <div className="mt-4">
              <Button onClick={tryAddAdditionalPlan}>+ Additional Plan</Button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AdditionPlansView;
